module.exports = __webpack_public_path__ + "static/img/event4.15450d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/event4.png
// module id = bu3D
// module chunks = 1